import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const audiencePoints = ['Sos nutricionista recién recibida/o armando tu primer consultorio', 'Tenés experiencia pero seguís usando sistemas informales', 'Atendés por obras sociales y necesitás documentación en regla', 'Querés ahorrar horas de trabajo administrativo cada semana', 'Buscás proyectar una imagen más profesional ante tus pacientes', 'Querés un seguimiento visual y objetivo del progreso de cada paciente'];
export function TargetAudience() {
  return <section className="py-20 bg-white" data-id="element-262">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-263">
        <div className="text-center mb-12" data-id="element-264">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-265">
            ESTO ES PARA VOS SI...
          </h2>
        </div>

        <div className="grid gap-4 md:grid-cols-2" data-id="element-266">
          {audiencePoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-nutri-mint/10 p-6 rounded-xl border border-nutri-mint/30" data-id="element-267">
              <div className="flex-shrink-0 mt-1" data-id="element-268">
                <div className="bg-nutri-medium p-1.5 rounded-full" data-id="element-269">
                  <Check className="text-white" size={20} data-id="element-270" />
                </div>
              </div>
              <p className="text-gray-800 font-medium leading-relaxed" data-id="element-271">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}